interface PropertyRejectionReasonCardProps {
    rejectionReason?: string;
}
const PropertyRejectionReasonCard = ({ rejectionReason }: PropertyRejectionReasonCardProps) => {
    return(
        <div
                            className="d-flex flex-column p-3 rounded mb-3"
                            style={{ background: '#f7f8fa' }}
                        >
                            <div className="d-flex align-items-center mb-1">
                                <div
                                    className="rounded-circle d-flex justify-content-center align-items-center me-2"
                                    style={{
                                        width: 28,
                                        height: 28,
                                        background: '#f3f4f6',
                                        border: '1px solid #d1d5db',
                                    }}
                                >
                                    <i className="ri-error-warning-line" style={{ fontSize: 18, color: '#e80e0eff' }}></i>
                                </div>
                                <span className="fw-bold" style={{ fontSize: 18 }}>Property Rejection Reason</span>
                            </div>
                            <div className="mt-2" style={{ fontSize: 17, lineHeight: 1.3 }}>
                                {rejectionReason}
                            </div>
                        </div>
    )
};

export default PropertyRejectionReasonCard;